import { Component, signal, ViewChild } from '@angular/core';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { OpsNeworeditEmailTemplate } from "./ops-neworedit-email-template/ops-neworedit-email-template";
import { Subscription } from 'rxjs/internal/Subscription';
import { ToastrService } from 'ngx-toastr';
import { EmailTemplateService } from 'src/app/services/EmailTemplate.service';
import { Column, GridComponent, FilterService } from '@syncfusion/ej2-angular-grids';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { EActionTypes, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';

@Component({
  selector: 'app-ops-email-templates',
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, TopBarComponent, OpsNeworeditEmailTemplate, LoaderComponent,
    UserPermissionHandlerDirective
  ],
  standalone: true,
  templateUrl: './ops-email-templates.html',
  styleUrl: './ops-email-templates.scss',
  providers: [FilterService],  
})
export class OpsEmailTemplates {
  private subscriptions: Subscription[] = [];
  
  response: any;
    
  isCollapsed = true;

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  EmailTemplateList = [];
  EditOrCreate = signal(false);
  @ViewChild("gridEmailTemplate", { static: false }) public gridEmailTemplate: GridComponent;

  editRight: boolean;
  viewRight: boolean;
  viewRightFalseMessage;
  editRightFalseMessage;
  createRight: boolean;
  deleteRight: boolean;
  createRightFalseMessage;
  deletRightFalseMessage;

  loaderIcon: Promise<boolean>;
  sub;
  selectedTemplate : object = {};

  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Email Templates'], Action: EActionTypes.CREATE };
  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Email Templates'], Action: EActionTypes.VIEW };
  deletePermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Email Templates'], Action: EActionTypes.DELETE };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Email Templates'], Action: EActionTypes.EDIT };
  

  constructor(
    private toastr: ToastrService,
    private EmailTemplateService: EmailTemplateService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService
  ) {

  }

  ngOnInit(): void {
    this.getTemplates()
  }

  ShowCreateOrEdit(){
    this.EditOrCreate.set(true);
  }

  HideCreateOrEdit(){
    this.EditOrCreate.set(false);
    this.selectedTemplate = {};
    this.getTemplates();
  }

  load() {
    ((this.gridEmailTemplate as GridComponent).columns[3] as Column).filterTemplate = '<span></span>';
  }

  getTemplates() {    
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.EmailTemplateService.GetAllEmailTemplateList().subscribe((res: any) => {     
      this.EmailTemplateList = res.map((el, i) => ({
        Id: el.EmailTemplateId,
        TemplateName: el.TemaplateName,
        TemplateType: el.TypeName,
        BaseTemplate: el.BaseTemplateName,        
      }));
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  deleteEmailTemplate(template) {
    Swal.fire({
      title: $localize`Are you sure ?`,
      text: $localize`Deleting template`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {
        this.loaderIcon = Promise.resolve(true);
        let selectedRec = template;
      
        this.subscriptions.push(this.EmailTemplateService.DeleteEmailTemplate(selectedRec.Id).subscribe((res: any[]) => {
          this.response = res;
          if (this.response.body.Success) {
            this.toastr.success($localize`Email template deleted successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            this.loaderIcon = Promise.resolve(false);
          }
          else {
            this.toastr.error($localize` Email Template delete was unsuccessful`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            this.loaderIcon = Promise.resolve(false);
          }
          this.getTemplates();
        }, (err) => {
          this.toastr.error($localize`Something went wrong delete failed`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
          this.loaderIcon = Promise.resolve(false);
        }));
           
      }
    });
  }

  RowChange(selectedItem: any) {
    const clickedElement = selectedItem.target;
    const selectedRowData = this.gridEmailTemplate?.getSelectedRecords()[0];
    
    if(clickedElement.cellIndex == 3 || clickedElement.parentNode.cellIndex == 3 || clickedElement.parentNode.nodeName == 'BUTTON'){
      return;
    }
    this.selectedTemplate = selectedRowData;
    this.ShowCreateOrEdit();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
